import {
    PARSE_CONFIG as PassportConfig,
    BLOCKS_CONFIG as PassportBlocksConfig
} from '@/storage/config/profileConfig/passportDataConfig'

import {
    PARSE_CONFIG as AddressSendConfig,
    BLOCKS_CONFIG as AddressBlocksConfig,
    GET_PROFILE_CONFIG as AddressParseConfig
} from '@/storage/config/profileConfig/addressConfig'

import {
    PARSE_CONFIG as EmploymentConfig,
    BLOCKS_CONFIG as EmploymentBlocksConfig
} from '@/storage/config/profileConfig/employmentConfig'

import {
    PARSE_CONFIG as ContactsSendConfig,
    BLOCKS_CONFIG as ContactsBlocksConfig,
    GET_PROFILE_CONFIG as ContactsParseConfig
} from '@/storage/config/profileConfig/relativeContactsConfig'


export const SEND_CONFIG = {
    ...PassportConfig,
    ...AddressSendConfig,
    ...EmploymentConfig,
    ...ContactsSendConfig
};

export const PARSE_CONFIG = {
    ...PassportConfig,
    ...AddressParseConfig,
    ...EmploymentConfig,
    ...ContactsParseConfig
};

export const BLOCKS_CONFIG = [
    ...PassportBlocksConfig,
    ...AddressBlocksConfig,
    ...EmploymentBlocksConfig,
    ...ContactsBlocksConfig
];

